import axios from "../../axiosConfig";
import { currentLanguage } from "../../../algorithms/storage";

export const getAllWorkTeams = (
  communityID,
  pageNumber = 1,
  pageSize = 100,
  token
) => {
  return axios.get(
    `Community/GetCommunityMembers/${communityID}/${pageNumber}/${pageSize}`,
    {
      headers: {
        "Accept-Language": currentLanguage(),
        Authorization: `Bearer ${token}`,
      },
    }
  );
};
